<template>
    <div
        v-if="resultData.totalCount"
        class="mb-2"
    >
        {{ $t('total_count') }}
        <Badge type="info">{{ resultData.totalCount }}</Badge>
    </div>
    <div v-if="resultData.errorCount">
        {{ $t('error_count') }}
        <Badge type="error">{{ resultData.errorCount }}</Badge>
    </div>
</template>

<script setup lang="ts">
import { Badge } from '@src/components'
import { PayoutTaskResultData } from '@src/types'
defineProps<{
    resultData: PayoutTaskResultData
}>()
</script>

<style scoped></style>
